/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum TaskDeputyMode {
    ALL = "ALL",
    MAIN = "MAIN_PARTICIPANT",
    DEPUTY = "DEPUTY"
}
